import * as ReactQuery from 'react-query';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { setAccessToken, setRefreshToken, setAuthProvider } from 'utils/auth';
import { Routing } from 'global/routing';
import { Store } from 'store';
import { externalOAuthSignInErrorMessage } from 'services/auth/external-oauth-sign-in-error';
import { idMeLoginApi } from './api';
import { getCurrentSiteEmployeeAPI } from 'services/site-employees/get-current-site-employee/api';

const IDME_LOGIN_KEY = '@auth/idme-login';

export function useIdMeLogin() {
  const history = useHistory();
  const intl = useIntl();
  const { showNotification } = Store.useNotifications();
  const { setUser } = Store.useUser();
  const { mutate, isLoading } = ReactQuery.useMutation(
    IDME_LOGIN_KEY,
    idMeLoginApi,
    {
      onSuccess: async (data) => {
        setAccessToken(data.id_token);
        setRefreshToken(data.refresh_token);
        setAuthProvider('idme');
        try {
          const employee = await getCurrentSiteEmployeeAPI();
          setUser(employee);
          history.push(Routing.HOME.getPath());
        } catch (err: any) {
          showNotification({
            variant: 'error',
            description:
              err?.message ||
              'Registration required. Please contact a clinlife administrator.',
            dismissible: true,
          });
          history.push(Routing.LOGIN.getPath());
        }
      },
      onError: () => {
        showNotification({
          variant: 'error',
          description: intl.formatMessage(externalOAuthSignInErrorMessage),
          dismissible: true,
        });
        history.push(Routing.LOGIN.getPath());
      },
    }
  );

  return {
    idMeLogin: mutate,
    isLoading,
  };
}
